import { IconTypes } from './Icons'

export default function CheveronLeftBold({
  color = '#CCCCDD',
  fontSize = '1.6rem',
  rotate = 0,
  className = '',
}: IconTypes) {
  return (
    <svg
      width='7'
      height='10'
      viewBox='0 0 7 10'
      fill='none'
      style={{
        width: '1em',
        height: '1em',
        fontSize,
        transform: `rotate(${rotate}deg)`,
      }}
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.175 1.175L5 0L0 5L5 10L6.175 8.825L2.35833 5L6.175 1.175Z'
        fill={color}
      />
    </svg>
  )
}
